import {DataContentWrapper} from '@hconnect/common/containers'
import {KpiType} from '@hconnect/common/types'
import {CardBox} from '@hconnect/uikit/src/lib2'
import {Typography} from '@mui/material'
import {Moment} from 'moment-timezone'
import {useTranslation} from 'react-i18next'

import {PerformanceReviewKpisTable} from '../components'
import {FEATURE_NAMESPACE} from '../consts'
import {usePerformanceReviewMonthlyKpis} from '../hooks'
import {mapPerformanceReviewKpisToTableData} from '../mappers'

type Props = {
  plantId: string
  selectedKpi?: KpiType
  selectedDate: Moment
  onKpiRowClick?: (kpiType: KpiType) => void
}

export const PerformanceReviewKpisContainer = ({
  plantId,
  selectedKpi,
  selectedDate,
  onKpiRowClick
}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {data, isLoading, isError, isRefetching, refetch} = usePerformanceReviewMonthlyKpis({
    plantId,
    requestedDate: selectedDate
  })
  const tableData = mapPerformanceReviewKpisToTableData(data)

  return (
    <CardBox data-test-id="kpis-table-card">
      <Typography variant="h3" mb={2}>
        {t('kpis.cardTitle')}
      </Typography>
      <DataContentWrapper
        showLoader={isLoading}
        isError={isError}
        isRefetching={isRefetching}
        data={data}
        retryFunction={() => void refetch()}
        progressSx={{color: 'primary.main'}}
      >
        <PerformanceReviewKpisTable
          responseDate={data?.yearMonth}
          data={tableData}
          selectedKpi={selectedKpi}
          onRowClick={onKpiRowClick}
        />
      </DataContentWrapper>
    </CardBox>
  )
}
